import { colors } from '../../colors';
var socialIcon = {
  fillColor: colors.white,
  fillHoverColor: colors.white,
  iconColor: colors.cornflowerBlue,
  iconHoverColor: colors.frenchBlue,
  iconBorderColor: colors.cornflowerBlue,
  iconBorderHoverColor: colors.frenchBlue
};
export default socialIcon;